"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatedDataTimeOutEvent = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
class UpdatedDataTimeOutEvent extends web_ui_framework_1.Event {
}
exports.UpdatedDataTimeOutEvent = UpdatedDataTimeOutEvent;
//# sourceMappingURL=timeOutEvents.js.map